// import files from "../../../../shared/files/files";
import LinkCell from "../LitComponents/LinkCell";
import LoadingCell from "../LitComponents/LoadingCell";
import VoidCell from "../LitComponents/VoidCell";
import PesquisaCabecalho from "../LitComponents/PesquisaCabecalho";
// import { valorMonetario } from "../../../../shared/tools/tools";
import ColorCell from "../LitComponents/ColorCell";
import { valorMonetario } from "@/shared/services/tools";
import files from "@/shared/files/files";
// import { valorMonetario } from "@/shared/services/tools";

const codigo_loading = 'LOAD'


/**
 * @enum {tiposDadoEnum}
 */
export const tiposDadoEnum = {
    text: 'text',
    status: 'status',
    custom: 'custom',
    link: 'link',
    monetario:'monetario',
    colorido: 'colorido',
}



const montaCabecalho = (coluna) => {
    let container = document.createElement('div');
    let tituloColuna = document.createElement('div');
    let containerIcones = document.createElement('div');
    let iconeParaBaixo = document.createElement('img');
    let iconeParaCima = document.createElement('img');

    tituloColuna.innerHTML += coluna.getColumn()._column.definition.title;

    iconeParaBaixo.src = files.retornaUrlImagem('down-long-solid.svg');
    iconeParaCima.src = files.retornaUrlImagem('up-long-solid.svg');

    iconeParaBaixo.style.width = '5px';
    iconeParaCima.style.width = '5px';
    iconeParaBaixo.classList.add(`icone_asc`);
    iconeParaCima.classList.add(`icone_desc`);

    containerIcones.append(iconeParaBaixo, iconeParaCima);
    containerIcones.id = `icones-${coluna.getColumn()._column.definition.field}`
    containerIcones.style.display = 'flex';


    container.append(tituloColuna, containerIcones);
    container.style.display = 'flex';
    container.style.gap = '0.5rem'

    return container;
}

const montaStatusCelula = (status = {}, ) => {

    let container = document.createElement('div');
    container.style.backgroundColor = status['corSecundaria'];
    container.style.color = status['corPrimaria'];
    container.style.borderRadius = '16px';
    container.style.width = '135px'
    container.style.height = '26px'
    container.style.textAlign = 'center'
    container.style.paddingTop = '0.3rem'
    container.style.paddingBottom = '0.3rem'
    container.style.display = 'flex'
    container.style.justifyContent = 'center'
    container.style.alignItems = 'center'
    container.innerHTML += status['nome'];
    return container;

}

/**
 *
 * @param {string} nome Nome que será exibido no cabeçalho do DataGrid
 * @param {string} prop O nome da propriedade que o DataGrid deve chamar para obter o dado
 * Exemplo: "usuario.nome"
 * @param {string} largura Largura da coluna em px. NÃO PASSAR px junto com o valor
 * @param {
 *      {
 *          ordena: boolean,
 *          tipoDeDado: string,
 *          formatter: func,
 *          clickLink: func,
 *          campoBusca: string,
 *          desformataNaBusca: boolean,
 *          naoMostraLoading: boolean,
 *          calculaCores: func,
 *      }
*   } opcoes
 * @returns Retorna o objeto de configuração da coluna
 */
export function coluna(nome = '', prop = '', largura = '150', opcoes = {
        ordena: false,
        campoBusca: false,
        tipoDeDado: 'text',
        clickLink: undefined,
        desformataNaBusca: undefined,
        naoMostraLoading: false,
        calculaCores: () => {},
        formatter: () => {}
    }){

    if(opcoes.tipoDeDado === undefined) opcoes.tipoDeDado = 'text'

    let paginacaoRemota = (typeof opcoes.ordena == 'string');

    //basico
    let retorno = {}
    retorno['title'] = nome;
    retorno['field'] = prop;
    retorno['naoMostraLoading'] = opcoes.naoMostraLoading
    retorno['headerSort'] = opcoes.ordena || false
    retorno['width'] = largura || '200';

    //formatador da coluna
    retorno['formatter'] = (e) => {
        if(e.getRow().getData()[prop] === '-') return new VoidCell();
        if(e.getRow().getData()[prop] === codigo_loading) return new LoadingCell();
        return e.getRow().getData()[prop]
    }

    //formatador do cabeçalho
    retorno['headerFilter'] = () => {
        const desformatar = opcoes.desformataNaBusca || prop.toLowerCase().includes('format');
        return new PesquisaCabecalho(opcoes.campoBusca, opcoes.campoBusca, desformatar);
    }

    //formatador do titulo
    if(opcoes.ordena){
        retorno['titleFormatter'] = montaCabecalho
    }

    if(opcoes.campoBusca){
        retorno['campoBusca'] = opcoes.campoBusca;
    }

    if(paginacaoRemota){
        retorno['sorter'] = () => { } //cancelando a páginação local.
        retorno['ordena'] = opcoes.ordena;
    }


    //formatações customizadas
    if(opcoes.tipoDeDado == 'status'){
        retorno['formatter'] = (e) => {
            return e.getRow().getData()[prop] == codigo_loading ? new LoadingCell() : montaStatusCelula(e.getRow().getData()[prop]);
        };
    }

    if(opcoes.tipoDeDado == 'link'){
        retorno['formatter'] = (e) => {
            if(e.getRow().getData()[prop] == codigo_loading){
                return new LoadingCell();
            }

            if(opcoes.clickLink !== undefined){
                return new LinkCell(e.getRow().getData()[prop], opcoes.clickLink);
            }

            return new LinkCell(e.getRow().getData()[prop]);

        };
    }

    if(opcoes.tipoDeDado == 'custom'){
        retorno['formatter'] = (e) => {
            return e.getRow().getData()[prop] == codigo_loading ? new LoadingCell() : opcoes.formatter(e);
        }
    }

    if(opcoes.tipoDeDado == 'monetario'){
        retorno['formatter'] = (e) => {
            return e.getRow().getData()[prop] == codigo_loading ? new LoadingCell() : valorMonetario(e.getRow().getData()[prop]);
        };
    }

    if(opcoes.tipoDeDado.includes('colorido')) {
        retorno['formatter'] = (e) => {
            return e.getRow().getData()[prop] == codigo_loading ? new LoadingCell() : new ColorCell(e.getRow().getData(), prop, opcoes.tipoDeDado.includes('monetario'), opcoes.calculaCores);
        }
    }

    return retorno;
}

export function colunaFixa(nome, formatter = () => document.createElement('div'), largura = 100){
    let retorno = {}
    retorno['title'] = nome;
    retorno['field'] = '';
    retorno['width'] = largura;
    retorno['resize'] = false;
    retorno['frozen'] = true;
    retorno['formatter'] = formatter;

    return retorno;
}

export function linhasLoading(quantidade = 15, colunas = []){
    let retorno = []
    for (let i = 0; i < quantidade; i++) {
        let linhaLoading = []
        colunas.forEach(x => {
            if(!x.naoMostraLoading){
                linhaLoading[x.field] = codigo_loading
                linhaLoading
            }
            else{
                linhaLoading[x.field] = ''
                linhaLoading
            }
        })
        retorno.push(linhaLoading);
    }

    return retorno;
}

export function colunaSelecionavel(){
    return {
        formatter:"rowSelection",
        titleFormatter:"rowSelection",
        hozAlign:"center",
        headerSort:false,
        cellClick: (e, cell) => {
            cell.getRow().toggleSelect();
        }
    }
}

